import { ShiftColumn } from '../../../models/shift-column.model';
import { ShiftLog } from '../../../models/shift-log.model';

/**
 * Columns definition for the handover table.
 */
export const SHIFT_COLUMNS: readonly ShiftColumn[] = [
  { key: 'checkbox', header: '', accessor: (l: ShiftLog) => '' },
  { key: 'activity', header: 'Activity Type', accessor: (l: ShiftLog) => l.activity || '' },
  { key: 'program', header: 'Program', accessor: (l: ShiftLog) => l.programName || '' },
  { key: 'createdDate', header: 'Created Date', accessor: (l: ShiftLog) => l.createdDate },
  { key: 'notes', header: 'Notes', accessor: (l: ShiftLog) => l.notes },
  { key: 'createdBy', header: 'Created by', accessor: (l: ShiftLog) => l.createdByName },
  { key: 'action', header: '', accessor: (l: ShiftLog) => '' },
] as const;
